module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Laptops Flagged","all":"All"}}')
  delete Component.options._Ctor
}
